import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'
import {connect} from 'react-redux'

import styles from '../styles'
import Item from '../components/item'
import actions from '../actions/item'
import rentActions from '../../rentV2/actions/orchestrator'
import loginActions from '../../login/actions/login'

class ItemContainer extends React.Component {

  constructor(props) {
    super(props)

    props.fetch(props.match.params.id)
  }

  render() {
    return <Item {...this.props}/>
  }
}

ItemContainer.propTypes = {
  match: PropTypes.object.isRequired,
  fetch: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const data = state.ui.item.item
  return {
    isFetching: data.get('isFetching'),
    error: data.get('error'),
    item: data.get('item'),
    isLoggedIn: state.domain.user.token !== '',
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetch: id => dispatch(actions.fetch(id)),
    startRent: item => dispatch(rentActions.start(item)),
    openLogin: () => dispatch(loginActions.open()),
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(ItemContainer)
const Styled = compose(withStyles(styles, {withTheme: true}), withWidth())(Container)

export default Styled



// WEBPACK FOOTER //
// ./src/sections/items/containers/item.js